import React, { useEffect, useState } from 'react';
import 'components/web/Deals/_deals.scss';
import PropTypes from 'prop-types';
import DealCard from './DealCard';
import { Link } from 'react-router-dom';
import Icon from '../../mweb/Icon/Icon';

const Deals = props => {
  const {
    title,
    products,
    info,
    moreInfo,
    moreInfoActionUrl,
    showSoldOut = true,
    minDealsCount = 0,
    source = '',
  } = props;
  const containerId = `deals--${Math.round(Math.random() * 100000)}`;
  let filteredProducts = products;
  if (!showSoldOut) {
    filteredProducts =
      products && products.filter(p => p.skus[0].isInventoryAvailable);
  }
  const [leftScroll, setleftScroll] = useState(0),
    [scrollWidth, setScrollWidth] = useState(0),
    [offsetWidth, setOffsetWidth] = useState(0);

  useEffect(() => {
    const scrollContainer = document.getElementsByClassName(containerId),
      { scrollWidth, scrollLeft, offsetWidth } = scrollContainer[0] || [];
    setScrollWidth(scrollWidth);
    setleftScroll(scrollLeft);
    setOffsetWidth(offsetWidth);
  }, []);

  const rightArrow = () => {
    const scrollContainer = document.getElementsByClassName(containerId),
      { scrollLeft, offsetWidth } = scrollContainer[0] || [];

    setleftScroll(offsetWidth + scrollLeft);
    scrollContainer[0].scroll({
      left: offsetWidth + scrollLeft,
      behavior: 'smooth',
    });
  };

  const leftArrow = () => {
    const scrollContainer = document.getElementsByClassName(containerId),
      { scrollLeft, offsetWidth } = scrollContainer[0] || [];

    setleftScroll(scrollLeft);
    scrollContainer[0].scroll({
      left: scrollLeft - offsetWidth,
      behavior: 'smooth',
    });
  };

  return (
    <React.Fragment>
      {filteredProducts?.length >= minDealsCount && (
        <React.Fragment>
          <div className="desktop-deals">
            <div className="desktop-deals--title-info">
              {title && <div className="desktop-deals--title">{title}</div>}
              {moreInfoActionUrl && moreInfo && (
                <Link
                  to={moreInfoActionUrl}
                  className="button action-link more"
                >
                  {moreInfo}
                </Link>
              )}
            </div>
            {info && (
              <div className="desktop-deals--more-info">
                <div className="desktop-deals--more-info--info">{info}</div>
              </div>
            )}
            <div className="desktop-deals-main">
              {leftScroll >= offsetWidth && filteredProducts.length > 2 && (
                <div className="desktop-deals-main--left-button">
                  <Icon
                    class="icon-arrow-scroll right-arrow"
                    size={50}
                    onClick={leftArrow}
                  />
                </div>
              )}
              <div className={`desktop-deals--container ${containerId}`}>
                {filteredProducts?.map(p => (
                  <DealCard product={p} key={p.productId} source={source} />
                ))}
              </div>
              {offsetWidth + leftScroll <= scrollWidth &&
                filteredProducts.length > 2 && (
                  <div className="desktop-deals-main--right-button">
                    <Icon
                      class="icon-arrow-scroll left-arrow"
                      size={50}
                      onClick={rightArrow}
                    />
                  </div>
                )}
            </div>
          </div>
          <div className="section-divider" />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

Deals.propTypes = {
  title: PropTypes.string,
  products: PropTypes.array.isRequired,
  info: PropTypes.string,
  moreInfo: PropTypes.string,
  moreInfoActionUrl: PropTypes.string,
  showSoldOut: PropTypes.bool,
  minDealsCount: PropTypes.number,
  source: PropTypes.string,
};

export default Deals;
